import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  NAME,
  ACTION_ADD,
  ACTION_REMOVE,
  ACTION_INIT,
  ACTION_CLEAR,
  ACTION_WRITE_ITEMS,
} from './consts';

const basket = namespace(NAME);

@Component
export default class StateModuleMixin extends Vue {
  @basket.State items: Array<any>;
  @basket.Action(ACTION_ADD) add: (item: any) => void;
  @basket.Action(ACTION_INIT) init: () => Promise<void>;
  @basket.Action(ACTION_CLEAR) clear: () => Promise<void>;
  @basket.Action(ACTION_REMOVE) remove: (id: any) => void;
  @basket.Action(ACTION_WRITE_ITEMS) write: (value: any) => void;

  saved({ id }: any): boolean {
    return this.items && !!this.items.find((item) => item.id === id);
  }

  toggle(data: any, isModuleSaved: boolean) {
    if (isModuleSaved) return this.remove(data.id);
    this.add(data);
  }
}



// WEBPACK FOOTER //
// ./src/services/modulebasket/stateModuleMixin.ts